import app from "./app";
import schemes from "./schemes";
import dealers from "./dealers";
import user from "./user";
import machine from "./machine";

import { combineReducers } from "redux";

const combinedReducer = combineReducers({
  app,
  schemes,
  dealers,
  user,
  machine,
});

export default combinedReducer;
